import type { ConstantOption } from './types';

const usd = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

/** Prices come from reware-api in cents. */
export const formatCents = (cents: number | null | undefined): string =>
  cents == null ? '—' : usd.format(cents / 100);

export const formatDateTime = (value: string | null | undefined): string => {
  if (!value) return '—';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? value : date.toLocaleString();
};

export const displayNameFor = (
  options: ConstantOption[],
  code: string | null | undefined
): string => {
  if (!code) return '—';
  return options.find(option => option.code === code)?.displayName ?? code;
};
